import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import { PermissionService } from '@app/authentication/services/permission.service';
import { SidebarVisibilityService } from '@app/core/services/sidebar-visibility.service';
import { JWTUser } from '@models/jwt-data.model';

type SectionId = 'tool' | 'strain';

@Component({
    selector: 'app-section-selection',
    templateUrl: './section-selection.component.html',
    styleUrls: ['./section-selection.component.scss']
})
export class SectionSelectionComponent implements OnInit {
    currentUser: JWTUser;
    hasToolSection = false;
    hasStrainSection = false;

    constructor(private authenticationService: AuthenticationService,
                private permissionService: PermissionService,
                private sidebarVisibilityService: SidebarVisibilityService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.currentUser = this.authenticationService.getUserDetails();
        this.hasToolSection = this.permissionService.hasSectionClaim(this.currentUser, 'TOOLMANAGEMENT');
        this.hasStrainSection = this.permissionService.hasSectionClaim(this.currentUser, 'STRAIN');


    }

    selectSection(section: SectionId): void {
        const items = section === 'tool' ? ['tool'] : ['strain'];
        this.sidebarVisibilityService.setSidebarItems(items);
        this.router.navigate(['/']);
    }
}
